import React from 'react';
import '@elastic/eui/dist/eui_theme_light.css';
import { EuiText, EuiFlexGroup, EuiFlexItem, EuiSpacer, EuiPageTemplate, EuiPageHeader, EuiImage } from '@elastic/eui';
import styled from 'styled-components';
import { Header } from '../components/header';
import { Footer } from '../components/footer';
import discussion3image1 from '../../documents/discussion3image1.png'

const StyledText = styled.div`
  ul.skills-list {
    display: grid;
    grid-gap: 0 10px;
    padding: 0;
    overflow: hidden;
    list-style: none;

    li {
      position: relative;
      font-family: var(--font-mono);
      font-size: var(--fz-xs);

      &:before {
        content: '• ';
        left: 0;
        color: var(--green);
        font-size: var(--fz-sm);
        line-height: 12px;
      }
    }
  }
`;
class Discussion3 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: [],
            isModalVisible: false,
            files: {},
            uploadDisabled: true,
            selection: [],
            columns: [],
            AlertText: "",
            AlertType: "error",
            discussion3Key: ['	Recommendation of relu activation function for regression problem',
            'Recommendation for ML models due to its interpretability nature ',
            'Annova for selection of the most influencing parameters in a phenomena','	The effect of lack of normalization of desired dataset on quality of analysis'],
            discussion3Value: ['	Problem Identification',  'Critical Appraisal', 'Enhanced Know How’s'],
        }
    }

    render() {

        return (
            <>
                <EuiPageTemplate>
                    <EuiPageHeader><Header /></EuiPageHeader>
                        <EuiSpacer />
                        <EuiText><h2><font face='Segoe UI'>Discussion of “Improvement in Estimating Durations for Building Projects Using Artificial Neural Network and Sensitivity Analysis” by Su-Ling Fan, I-Cheng Yeh and Wei-Sheng </font></h2></EuiText>
                        <EuiSpacer size='m' />
                        <EuiText><h5><font face='Segoe UI'> 
                        Duration: May 2021 – Present</font></h5></EuiText>
                        <EuiSpacer size='m' />
                <EuiFlexGroup gutterSize='xl'>
                <EuiFlexItem>
                <EuiText>
                        <b>Key Highlights</b> 
                        <StyledText><ul className="skills-list">
                        {this.state.discussion3Key && this.state.discussion3Key.map((p, i) => <li key={i}>{p}</li>)}
                        </ul></StyledText>
                        <b>Value Additions</b>
                        <StyledText><ul className="skills-list">
                        {this.state.discussion3Value && this.state.discussion3Value.map((p, i) => <li key={i}>{p}</li>)}
                        </ul></StyledText></EuiText>
                </EuiFlexItem><div><EuiFlexGroup direction='column'>
                <EuiFlexItem ><EuiText textAlign='center'><EuiImage size='l' src={discussion3image1} />
                <EuiSpacer size = 's'/>
                Adam Optimizer Recommendation over other Optimizers for ANN
                   (Verma et al. 2020) </EuiText></EuiFlexItem></EuiFlexGroup></div>
                </EuiFlexGroup>
            <Footer /></EuiPageTemplate>
            </>
        )
    }
};

export { Discussion3 }